import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

import { Icon } from '@sdb/planning-ui';

interface CreateButtonProps extends ButtonProps {
  label?: string;
  ml?: number | 'auto';
}

/**
 * This button is mostly used for creating a new record at admin tables
 */
const CreateButton: React.FC<CreateButtonProps> = ({ onClick, label, ml }) => {
  const { t } = useTranslation('common');

  return (
    <div style={{ display: 'flex' }}>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        startIcon={<Icon type="plus" sx={{ m: 'auto' }} />}
        onClick={onClick}
        sx={{ ml: ml || 'auto', alignItems: 'left' }}
      >
        {label ? label : t('new')}
      </Button>
    </div>
  );
};

export default CreateButton;
